import React from 'react'

import { Constrain } from '../@primitives/constrain'
import { Button } from '../@primitives/button'

import styled from 'react-emotion'
import { colors } from '../../styles/vars'

const Grid = styled('div')`
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(${props => props.columns ? props.columns : 3}, 1fr);
  grid-gap: ${props => props.gap ? props.gap : 20}px;
  position: relative;
  direction: ${props => props.direction ? props.direction : 'ltr'};
  
  div {
    direction: ltr;
    
  }
   
  @media (max-width: 768px) {
    grid-template-columns: repeat(${props => props.mobile ? props.mobile : 2}, 1fr);
    direction: ltr;
  }
`

const HeroStyles = styled('div')`
  background-color: ${colors.white};
  position: relative;
  
  & > div > div {
  
    @media (min-width: 769px) {
      padding-bottom: 0;
    }
  }
  
  ${Grid} {
    align-items: center;
    
    @media (max-width: 425px) {
      grid-gap: 20px;
      margin-bottom: 20px;
    }
  }
  
  img {
    max-width: 100%;
    height: auto;
    border-radius: 6px;
    overflow: hidden;
  }
  
  
`

export const Hero = (props) =>
  <HeroStyles>
    <Constrain>
      <Grid columns={2} mobile={1} direction={"rtl"}>
        <div>
          {props.imageUrl ?
            <a href={props.imageUrl}>
              <img src={props.image} alt=""/>
            </a> :
            <img src={props.image} alt=""/>
          }
        </div>
        <div>
          <h1>{props.heading}</h1>
          <p>{props.content}</p>
          {props.to &&
            <Button to={props.to}>{props.text || 'Learn More'}</Button>
          }
        </div>
      </Grid>
    </Constrain>

  </HeroStyles>



// WEBPACK FOOTER //
// ./src/components/Hero/index.js